<template>
	<div class="global-new-button" :style="{ width: fullWidth ? '100%' : 'auto' }">
		<v-menu offset-y v-model="menu" min-width="240" :nudge-bottom="6" content-class="global-menu-content" z-index="999">
			<template v-slot:activator="{ on, attrs }">
				<v-btn
					v-bind="attrs"
					v-on="on"
					class="custom-button-global-new"
					:class="{ 'menu-open': menu }"
					tile
					:block="fullWidth"
					depressed>
					<div class="btn-inner d-flex align-center">
						<v-icon class="btn-icon" :color="menu ? 'white' : '#2D4B95'">mdi-view-grid-plus-outline</v-icon>
						<div class="btn-divider mx-2"></div>
						<div class="btn-text">
							<p class="mb-0 font-weight-bold text-capitalize btn-main">Crear</p>
							<p class="mb-0 text-capitalize btn-sub">Nuevo Elemento</p>
						</div>
						<v-icon class="btn-chevron ml-3" small :color="menu ? 'white' : '#2D4B95'">mdi-chevron-down</v-icon>
					</div>
				</v-btn>
			</template>

			<v-list dense class="global-menu-list pa-0">
				<div class="menu-header px-3 py-2">
					<span class="menu-header-label">Nuevo elemento</span>
				</div>

				<v-divider class="menu-divider"></v-divider>

				<v-list-item class="menu-item px-2">
					<v-btn block text class="global-new-item"
						@click="createTarea">
						<div class="item-icon-wrap mr-3">
							<v-icon small>mdi-clipboard-text-outline</v-icon>
						</div>
						<span>Nueva Tarea</span>
						<v-icon class="item-arrow ml-auto" x-small>mdi-plus</v-icon>
					</v-btn>
				</v-list-item>

				<v-list-item class="menu-item px-2">
					<v-btn block text class="global-new-item"
						@click="createRdi">
						<div class="item-icon-wrap mr-3">
							<v-icon small>mdi-file-document-multiple-outline</v-icon>
						</div>
						<span>Nueva RDI</span>
						<v-icon class="item-arrow ml-auto" x-small>mdi-plus</v-icon>
					</v-btn>
				</v-list-item>

					<v-list-item class="menu-item px-2" v-if="checkPermissions(['create_communication_book_folios'])">
						<v-btn block text class="global-new-item"
							@click="createCommunicationFolio">
							<div class="item-icon-wrap mr-3">
								<v-icon small>mdi-book-open-page-variant-outline</v-icon>
							</div>
							<span>Nuevo Folio</span>
							<v-icon class="item-arrow ml-auto" x-small>mdi-plus</v-icon>
						</v-btn>
					</v-list-item>


				<v-list-item class="menu-item px-2">
					<v-btn block text class="global-new-item"
						@click="createPosibleAdicional">
						<div class="item-icon-wrap mr-3">
							<v-icon small>mdi-notebook-plus-outline</v-icon>
						</div>
						<span>Nuevo Posible Adicional</span>
						<v-icon class="item-arrow ml-auto" x-small>mdi-plus</v-icon>
					</v-btn>
				</v-list-item>

				<v-list-item class="menu-item px-2">
					<v-btn block text class="global-new-item"
						@click="createEntrega">
						<div class="item-icon-wrap mr-3">
							<v-icon small>mdi-format-list-checks</v-icon>
						</div>
						<span>Nueva Entrega</span>
						<v-icon class="item-arrow ml-auto" x-small>mdi-plus</v-icon>
					</v-btn>
				</v-list-item>

				<v-list-item class="menu-item px-2">
					<v-btn block text class="global-new-item"
						@click="createMeeting">
						<div class="item-icon-wrap mr-3">
							<v-icon small>mdi-calendar</v-icon>
						</div>
						<span>Nueva Reunión/Minuta</span>
						<v-icon class="item-arrow ml-auto" x-small>mdi-plus</v-icon>
					</v-btn>
				</v-list-item>
			</v-list>
		</v-menu>
	</div>
</template>

<script>
export default {
	name: 'GlobalNewButton',
	props: {
		fullWidth: {
			type: Boolean,
			default: false
		}
	},
	data: () => ({
		menu: false
	}),
	methods: {
		createTarea() {
			this.menu = false
			this.$store.consultasStore.commit('setCreateTareaModal', true)
		},
		createRdi() {
			this.menu = false
			this.$store.rdiStore.commit('setCreateRDIModal', true)
		},
		createCommunicationFolio() {
			this.menu = false
			this.$store.communicationBooksStore.commit('setCreateFolioModal', true)
		},
		createAdicional() {
			this.menu = false
			this.$store.adicionalesStore.commit('setCreateAdicionalModal', true)
		},
		createPosibleAdicional() {
			this.menu = false
			this.$store.adicionalesStore.commit('setCreatePosibleAdicionalModal', true)
		},
		createEntrega() {
			this.menu = false
			this.$store.entregaStore.commit('setCreateEntregaModal', true)
		},
		createMeeting() {
			this.menu = false
			this.$store.meetingStore.commit('setCreateMeetingModal', true)
		}
	}
}
</script>

<style scoped>
/* ===========================
   Wrapper
=========================== */
.global-new-button {
	display: inline-block;
}

/* ===========================
   Botón activador - base
=========================== */
.custom-button-global-new.v-btn {
	background-color: white !important;
	color: #2D4B95 !important;
	border: 1.5px solid #2D4B95 !important;
	border-radius: 6px !important;
	padding: 0 14px !important;
	height: 100% !important;
	box-shadow: inset 0 0 0 2px rgba(45, 75, 149, 0.07) !important;
	transition: background-color 0.18s ease, color 0.18s ease, box-shadow 0.18s ease !important;
	text-transform: none;
	letter-spacing: 0;
}

/* Eliminar overlay/ripple de Vuetify */
/deep/ .custom-button-global-new.v-btn::before {
	display: none !important;
}

/* Estado normal (sin hover, sin menú abierto) */
.custom-button-global-new.v-btn:not(.menu-open):not(:hover) {
	background-color: white !important;
	color: #2D4B95 !important;
	box-shadow: inset 0 0 0 2px rgba(45, 75, 149, 0.07) !important;
}

/* Hover */
.custom-button-global-new.v-btn:hover {
	background-color: #2D4B95 !important;
	color: white !important;
	box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.15) !important;
}

/* Menú abierto → azul (con o sin hover) */
.global-new-button .custom-button-global-new.menu-open.v-btn,
.global-new-button .custom-button-global-new.menu-open.v-btn:not(:hover) {
	background-color: #2D4B95 !important;
	color: white !important;
	box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.15) !important;
}

.btn-inner {
	color: inherit;
}

/* ===========================
   Íconos del activador
=========================== */

/* Normal: azul */
/deep/ .custom-button-global-new.v-btn:not(.menu-open):not(:hover) .v-icon {
	color: #2D4B95 !important;
	transition: color 0.18s ease;
}

/* Hover: blanco */
/deep/ .custom-button-global-new.v-btn:hover .v-icon {
	color: white !important;
}

/* ===========================
   Elementos internos del botón
=========================== */
.btn-icon {
	font-size: 20px !important;
}

.btn-divider {
	width: 1px;
	height: 26px;
	background: rgba(45, 75, 149, 0.25);
	flex-shrink: 0;
	transition: background 0.18s ease;
}

.custom-button-global-new.v-btn:hover .btn-divider,
.global-new-button .custom-button-global-new.menu-open .btn-divider {
	background: rgba(255, 255, 255, 0.3);
}

.btn-main {
	font-size: 13px !important;
	font-weight: 600 !important;
	color: inherit !important;
	line-height: 1.2;
}

.btn-sub {
	font-size: 10px !important;
	color: inherit !important;
	opacity: 0.6;
	line-height: 1.2;
}

.btn-chevron {
	font-size: 16px !important;
	opacity: 0.6;
	transition: transform 0.2s ease !important;
}

.menu-open .btn-chevron {
	transform: rotate(180deg);
}

/* ===========================
   Menú desplegable
=========================== */
/deep/ .global-menu-content {
	border-radius: 8px !important;
	border: 1px solid rgba(45, 75, 149, 0.18) !important;
	box-shadow: 0 4px 20px rgba(45, 75, 149, 0.12), 0 1px 4px rgba(0,0,0,0.06) !important;
	overflow: hidden;
}

.global-menu-list {
	background: white;
}

.menu-header {
	background: rgba(45, 75, 149, 0.04);
}

.menu-header-label {
	font-size: 10px;
	font-weight: 600;
	color: #2D4B95;
	opacity: 0.55;
	text-transform: uppercase;
	letter-spacing: 0.08em;
}

.menu-divider {
	border-color: rgba(45, 75, 149, 0.1) !important;
}

.menu-item {
	padding-top: 2px !important;
	padding-bottom: 2px !important;
	min-height: unset !important;
	border-bottom: 0.5px solid rgba(45, 75, 149, 0.06);
}

.menu-item:last-child {
	border-bottom: none;
}

.global-new-item.v-btn {
	justify-content: flex-start !important;
	color: #2D4B95 !important;
	text-transform: none !important;
	letter-spacing: 0 !important;
	font-size: 13px !important;
	font-weight: 500 !important;
	height: 40px !important;
	border-radius: 6px !important;
	transition: background 0.12s ease !important;
}

.global-new-item.v-btn:hover {
	background: rgba(45, 75, 149, 0.06) !important;
}

/deep/ .global-new-item .v-icon {
	color: #2D4B95 !important;
}

.item-icon-wrap {
	width: 28px;
	height: 28px;
	border-radius: 6px;
	background: rgba(45, 75, 149, 0.08);
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	transition: background 0.12s;
}

.global-new-item:hover .item-icon-wrap {
	background: rgba(45, 75, 149, 0.16);
}

.item-arrow {
	opacity: 0;
	transition: opacity 0.12s;
}

.global-new-item:hover .item-arrow {
	opacity: 1;
}

.global-new-item.v-btn--disabled {
	opacity: 0.4 !important;
}
</style>